module.exports = __webpack_public_path__ + "media/images/red-trash-without-circle-4de97612.svg";